/**
 * ainw.university (Unify) — runtime host gate.
 *
 * The brand theme (palette + fonts) is NOT hardcoded here. It is set per-workspace in the
 * backend workspace config (`appConfig.theme`), which `<Provider>` deep-merges over the default
 * `@lyearn/style` theme — so the whole re-skin is config-driven and affects no other tenant.
 * The full token map to load into the workspace config lives in `UNIFY_THEME_HANDOFF.md`.
 *
 * This gate exists only for the one thing that can't be expressed as a theme token: the nav
 * logo box is sized up for the ainw wordmark (see Header/DefaultLeftNode). It matches by host,
 * so prod needs no env var and no per-tenant build.
 */
export const shouldUseUnifyTheme = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const host = window.location.hostname.toLowerCase();

  return host.includes('ainw.university') || host.startsWith('ainw.');
};
